var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FixItem',{attrs:{"label":"システムID","value":_vm.user.system_id}}),_c('FixItem',{attrs:{"label":"メールアドレス","value":_vm.user.mail_address}}),_c('FixItem',{attrs:{"label":"携帯電話番号","value":_vm.user.tel_no}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }